//@flow
import * as React from 'react'
import type { PhobosQualityReviewContainer$Props } from './flowTypes'
import ContainerRowExpandPanel from '../../components/common/ContainerRowExpandPanel'
import QualityReviewContainer from '../../components/QualityReview/QualityReviewContainer'

const PhobosQualityReviewContainer=(props:PhobosQualityReviewContainer$Props)=>{
    const phobos = props.phobos
    let isVisible = false

    if (phobos.reviewQuestions && phobos.reviewQuestions.length > 0){
        isVisible = true
    }
    
    return (
        <ContainerRowExpandPanel visible={isVisible} 
        title={'Final Review Before Submission'} elementId={'letoQualityReview'} 
        errors={props.noOfErros}
        >
            <QualityReviewContainer 
                elementId={'phobosPanelReviewQuestion'} 
                changeFieldValue={props.changeFieldValue} 
                questions={(phobos.reviewQuestions:any)} 
            />
        </ContainerRowExpandPanel>
    )
}

export default PhobosQualityReviewContainer


// WEBPACK FOOTER //
// ./src/views/ProjectPhobos/PhobosQualityReviewContainer.js